module.exports = __webpack_public_path__ + "assets/credit-card-logo.c5197f17.svg";